import TranselitLogo from '../assets/transelit-icon.svg';
import DonarisLogo from '../assets/donaris-icon.svg';
import IntactLogo from '../assets/intact-icon.svg';
import TranselitPolicy from '../assets/PDF/transelit_policy.pdf';
import DonarisPolicy from '../assets/PDF/donaris_policy.pdf';
import IntactPolicy from '../assets/PDF/intact_policy.pdf';

export const companyLogo: { [name: string]: any } = {
  transelit: TranselitLogo,
  donaris: DonarisLogo,
  intact: IntactLogo,
};

export const companyStandartOptions = [
  { title: 'ambulatory_treatment', amount: '40 000 €' },
  { title: 'doctor_call', amount: '40 000 €' },
  { title: 'transportation_to_doctor', amount: '40 000 €' },
  { title: 'emergency_medical_care', amount: '40 000 €' }, 
];

export const companyAdditionalOptions = [
  { title: 'medicines', amount: '40 000 €' },
  { title: 'accident', amount: '40 000 €' },
  { title: 'cover_covid_risks', amount: '100 €' },  
];

export const companyLinkInsuranceRules: { [name: string]: any } = {
  transelit: 'https://drive.google.com/file/d/1yGVD7eKQ4lceSCIXuChS8VICp417-wlu/view?usp=sharing',
  donaris: 'https://drive.google.com/file/d/1v44YzZcVEWzKUJG0A62WSCD0lqT9d7S6/view?usp=sharing',
  intact: 'https://drive.google.com/file/d/1GxhUN0VPvE4kZ4mu21yAtCPJtDGBa613/view?usp=sharing',
}

export const companyOptionsNumber: { [name: string]: any } ={
  transelit: '8',
  donaris: '9',
  intact: '5',
}

export const companyPolicyExample: { [name: string]: any } = {
  transelit: TranselitPolicy,
  donaris: DonarisPolicy,
  intact: IntactPolicy,
}
